import request from '@/services/request'

export default {
  productReview: {
    url: '/productReview/page',
    method: 'post',
    desc: 'review初始数据'
  },
  feedbackPage: {
    url: '/feedback/report/page',
    method: 'post',
    desc: 'feedback三星以上'
  },
  feedbackCrawPage: {
    url: '/feedback/report/crawPage',
    method: 'post',
    desc: 'feedback四星以上'
  },
  comments: {
    url: '/productReview/comments',
    method: 'post',
    desc: '修改备注'
  },
  batchProcess: {
    url: '/productReview/batchProcess',
    method: 'post',
    desc: '批量操作'
  },
  collectGoodsMonitor: {
    url: '/review/monitor/collectGoodsMonitor',
    method: 'post',
    desc: '收藏'
  },
  getProductReviewOrderList: {
    url: '/productReview/getProductReviewOrderList',
    method: 'post',
    desc: '获取相关订单分页'
  },
  // 匹配订单
  getProductReviewMatchOrderPage: {
    url: '/productReview/getProductReviewMatchOrderPage',
    method: 'post',
    desc: '可选订单分页'
  },
  addProductReviewOrder: {
    url: '/productReview/addProductReviewOrder',
    method: 'post',
    desc: '新增关联订单'
  },
  deleteProductReviewOrder: {
    url: '/productReview/deleteProductReviewOrder',
    method: 'post',
    desc: '删除关联订单'
  },
  /**
   * 获取商品属性列表
   * @param {*} data { asin countryCode }
   * @param {*} options
   * @returns
   */
  fetchProductAttrList: (data, options = {}) => {
    return request(
      {
        url: '/productReview/getProductReviewSku',
        method: 'post',
        desc: '获取商品属性列表'
      },
      data,
      options
    )
  }
}
